import React from 'react';
import { Link } from 'gatsby';
import PhoneSVG from '../images/icons/phone-ico.svg';
import WatchSVG from '../images/icons/hours-ico.svg';
import { navigate } from 'gatsby';
import Config from '../config';

const ServicePagePortal = (props) => {

    const routes = Config.Services.ServiceRoutes;
    return (
        <div className="service-right-bar-component">
            <div className="row d-none d-lg-block">
                <div className="col-12 text-center">
                    <ul className="list-inline service-inner-navigation">
                        <li className={props.activePath === routes.featuredServices ? 'list-inline-item active' : 'list-inline-item'}>
                            <Link to={routes.featuredServices}>Featured Services</Link>
                        </li>
                        <li className={props.activePath === routes.designAndDecorating ? 'list-inline-item active' : 'list-inline-item'}>
                            <Link to={routes.designAndDecorating}>Design and Decorating</Link>
                        </li>
                        <li className={props.activePath === routes.installationService ? 'list-inline-item active' : 'list-inline-item'}>
                            <Link to={routes.installationService}>Installation Services</Link>
                        </li>
                        <li className={props.activePath === routes.repairService ? 'list-inline-item active' : 'list-inline-item'}>
                            <Link to={routes.repairService}>Repair Services</Link>
                        </li>
                        <li className={props.activePath === routes.serviceInformation ? 'list-inline-item active' : 'list-inline-item'}>
                            <Link to={routes.serviceInformation}>Service Information</Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    {props.children}
                </div>
                <div className="col-12 col-md-4">
                    <div className="col-12 mt-md-5 pr-3 pt-3 pb-3 pl-3 shedule-your-appointment-today-box">
                        <div className="row">
                            <div className="col-12">
                                <h3 className="text-center" >Schedule your appointment today!</h3>
                            </div>
                            <div className="col-12">
                                <ul className="list-inline">
                                    <li className="list-inline-item"><img className="icon" src={PhoneSVG} alt="phone" /></li>
                                    <li className="list-inline-item ml-0">(201) 475-7711</li>
                                </ul>
                            </div>
                            <div className="col-12">
                                <ul className="list-inline">
                                    <li className="list-inline-item"><img className="icon" src={WatchSVG} alt="watch" /></li>
                                    <li className="list-inline-item">Monday to Saturday: 8am to 5pm</li>
                                    <li className="pl-4">Sunday:Closed</li>
                                </ul>
                            </div>
                            <div className="col-12 text-center">
                                <button className="main-button" onClick={() => { navigate('/contact') }}>GET IN TOUCH</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServicePagePortal;